module.exports = __webpack_public_path__ + "img/theme-a.68c12fdf.png";